module.exports = __webpack_public_path__ + "media/images/dashboard/bronze-371483cea925e1ddd10c1fca4494813e.svg";